import { getFunctions, httpsCallable } from 'firebase/functions'
import { app } from '../lib/firebase'

/**
 * SIKKER MAILUDSENDELSE
 *
 * Tilbud sendes ALDRIG direkte fra browseren. Frontend kalder udelukkende en
 * Firebase Cloud Function ("sendQuoteEmail"), som kører på serveren og selv
 * holder alle hemmeligheder (Microsoft 365 / Graph client secret, SMTP-kode,
 * API-nøgler). Ingen credentials findes i denne kode eller i bundlen.
 *
 * Flow:  Admin → Firebase Function → Microsoft 365 (kontakt@lykkeværk.dk) → kunde
 *
 * Funktionen skal kræve en gyldig admin-session (context.auth) og afvise alt andet.
 * Se docs/email-backend.md for den serverside-implementering, der skal udrulles.
 */
const functions = getFunctions(app, 'europe-west1')

export interface SendQuoteEmailPayload {
  quoteId: string
  quoteNumber: string
  to: string
  subject: string
  message: string
  /** PDF'en som base64 — vedhæftes af backend. */
  pdfBase64: string
  fileName: string
}

export interface SendQuoteEmailResult {
  ok: boolean
  /** Fejlbesked fra backend, hvis afsendelsen ikke lykkedes. */
  error?: string
}

export async function sendQuoteEmail(payload: SendQuoteEmailPayload): Promise<SendQuoteEmailResult> {
  const callable = httpsCallable<SendQuoteEmailPayload, SendQuoteEmailResult>(
    functions,
    'sendQuoteEmail',
  )
  const response = await callable(payload)
  return response.data ?? { ok: false, error: 'Backend svarede ikke.' }
}
